import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/southzone-ils-logo.png";
import text from "../../assets/southzone-ils-text.png";
import "./header.css";

const Header = () => {
  const location = useLocation();
  const menuOptions = [
    { label: "Home", link: "#home" },
    { label: "About", link: "#about" },
    { label: "Contact", link: "#contact" },
    { label: "Products", link: "#products" },
  ];

  const industryProducts = {
    "Crushers and Mining": ["Engine Oil 15w40", "Engine Oil 20w40", "Gear Oil 90/140/80w90/85w140", "Grease EPL2", "AdBLU", "Hydraulic Oil 32/46/68", "Castrol Triol PD EP2 Grease"],
    "Rubber": ["Aromatic Oil", "Paraffanic Oil", "Naphtenic Oil"],
    "Logistics and Transportation": ["Engine Oil 15w40", "Engine Oil 20w40", "Gear Oil 90/140/80w90/85w140", "Grease EPL2", "AdBLU"],
    "Cold Storage Plants": ["Ammonia Cooling Compressor Oil"]
  }; 
  const transformedIndustryProducts = Object.entries(industryProducts).flatMap(([industry, products]) => {
    const mappedProducts = products.map(product => `${industry} > ${product}`);
    return [ industry, ...mappedProducts ];
  });

  const [activeNav, setActiveNav] = useState("Home");
  const [ suggestions, setSuggestions ] = useState([]);
  const [ searchText, setSearchText ] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false); 

  let currentIndex = -1;

  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.startsWith("/industry-products")) {
      setActiveNav("Products");
    } else {
      setActiveNav(menuOptions.find(menuOption => menuOption.link === location.hash)?.label);
    }

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); 
    };
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [location]);

  const handleSearch = (e) => {
    setSearchText(e.target.value);

    if(e.target.value.length > 2) {
      setSuggestions(transformedIndustryProducts.filter(product => product.toLowerCase().includes(e.target.value.toLowerCase())));
    } else if (e.target.value.length <= 2) {
      setSuggestions([]);
    }
  };

  const handleClose = () => {
    setSearchText("");
    setSuggestions([]);
  }

  const handleKeyDown = (e) => {
    if(e.key === "ArrowDown") {
      e.preventDefault();
      currentIndex = (currentIndex + 1) % suggestions.length;
      updateFocus();
    } else if(e.key === "ArrowUp") {
      e.preventDefault();
      currentIndex = (currentIndex - 1 + suggestions.length) % suggestions.length;
      updateFocus();
    } else if(e.key === "Enter" && currentIndex !== -1) {
      e.preventDefault();
      document.querySelectorAll(".suggestion-item")[currentIndex].click();
    }
  };

  const updateFocus = () => {
    document.querySelectorAll(".suggestion-item").forEach((item, index) => {
      if(index === currentIndex) {
        item.classList.add("highlight");
        item.scrollIntoView({ block: 'nearest' });
      } else {
        item.classList.remove("highlight")
      }
    })
  };

  const handleSuggestion = (suggestion) => {
    const navIndex = suggestion.indexOf(" >");
    if(navIndex > 0) {
      navigate(`/industry-products/${suggestion.slice(0, navIndex)}`);
    } else {
      navigate(`/industry-products/${suggestion}`)
    }
    
    setSuggestions([]);
    setSearchText("");
  }

  return (
    <header className="header-container">
      <div className="header-logo" onClick={() => navigate('/#home')}>
        <img className="logo" src={logo} alt="Company Team" />
        <img className="text" src={text} alt="Company Team" />
      </div>
      <div className="header-search">
        <input
          type="text"
          placeholder="Search products..."
          className="search-input"
          value={searchText}
          onChange={handleSearch}
          onKeyDown={handleKeyDown}
        />
        <span className="close-search" onClick={handleClose}>X</span>
        <div className={`suggestions-box ${suggestions.length > 0 ? "active" : ""}`}>
          {
            suggestions.map(suggestion => {
              const matchIndex = suggestion.toLowerCase().indexOf(searchText.toLowerCase());
              const beforeMatch = suggestion.slice(0, matchIndex);
              const matchText = suggestion.slice(matchIndex, matchIndex + searchText.length);
              const afterMatch = suggestion.slice(matchIndex + searchText.length);

              return (<div className="suggestion-item" key={suggestion} onClick={() => handleSuggestion(suggestion)}>
                {beforeMatch}
                <strong>{matchText}</strong>
                {afterMatch}
              </div>);
            })
          }
        </div>
      </div>
      {isMobile && (
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      )}

      <nav className={`header-menu ${isMobile && menuOpen ? "open" : ""}`}>
        {menuOptions.map((option, index) => (
          <a
            key={index}
            href={option.link}
            className={`menu-item ${activeNav === option.label ? "active-menu-item" : ""}`}
            onClick={() => {
              setActiveNav(option.label);
              setMenuOpen(false);
            }}
          >
            {option.label}
          </a>
        ))}
      </nav>
    </header>
  );
};

export default Header;
